module.exports = __webpack_public_path__ + "static/media/alarm-clock.fe23524f.png";